import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from '@/context/AuthContext';
import { SubscriptionProvider } from '@/context/SubscriptionContext';
import Login from '@/pages/Login';
import Register from '@/pages/Register';
import Dashboard from '@/pages/Dashboard';
import Screener from '@/pages/Screener';
import Portfolio from '@/pages/Portfolio';
import AIIdeas from '@/pages/AIIdeas';
import StockDetail from '@/pages/StockDetail';
import OptionsChain from '@/pages/OptionsChain';
import Pricing from '@/pages/Pricing';
import PaymentSuccess from '@/pages/PaymentSuccess';
import MarketIntel from '@/pages/MarketIntel';
import Backtest from '@/pages/Backtest';
import PaperTrading from '@/pages/PaperTrading';
import AlertsPage from '@/pages/Alerts';
import { Toaster } from '@/components/ui/sonner';

function App() {
  return (
    <AuthProvider>
      <SubscriptionProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/screener" element={<Screener />} />
            <Route path="/portfolio" element={<Portfolio />} />
            <Route path="/ai-ideas" element={<AIIdeas />} />
            <Route path="/stock/:symbol" element={<StockDetail />} />
            <Route path="/options" element={<OptionsChain />} />
            <Route path="/market-intel" element={<MarketIntel />} />
            <Route path="/backtest" element={<Backtest />} />
            <Route path="/paper-trading" element={<PaperTrading />} />
            <Route path="/alerts" element={<AlertsPage />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
          </Routes>
        </BrowserRouter>
        <Toaster />
      </SubscriptionProvider>
    </AuthProvider>
  );
}

export default App;
